import React, { Component } from 'react';

import './BasketUpsellItemContent.scss';

import { UpsellModel } from 'models/Basket';
import { upsellContentItems, UpsellContentItem } from '../upsellContentItems';

interface OwnProps {
    upsellItem: UpsellModel;
}

interface OwnState {
    upsellContentItem: UpsellContentItem | null;
}

export class BasketUpsellItemContent extends Component<OwnProps, OwnState> {
    constructor(props: OwnProps) {
        super(props);
        this.state = {
            upsellContentItem: this.getUpsellContentItem()
        };
    }

    render(): JSX.Element {
        const upsellContentItem = this.state.upsellContentItem!;

        return (
            <div className='upsell-item-content'>
                {upsellContentItem.text.map((textItem, index, textArray) => (
                    <p key={textItem}>
                        {textItem}
                        {(index === (textArray.length - 1))
                          && <a href={upsellContentItem.helpLink.path} rel='noopener noreferrer' target='_blank'> {upsellContentItem.helpLink.title}&nbsp;
                              <i className='sa sa-external-link upsell-help-link'></i>
                          </a>}
                    </p>
                ))}
            </div>
        );
    }

    getUpsellContentItem(): UpsellContentItem {
        return upsellContentItems.find(u => u.id === this.props.upsellItem.type)!;
    }
}